import React from 'react';
import Navbar from '../navbar/Navbar';
import Footer from '../footer/Footer';
import { Outlet } from 'react-router-dom';
export default function Wrapper() {
  return <><Navbar /><div id="page-content" tabIndex="-1"><Outlet /></div><Footer /></>;
}
